import { Controller } from '@hotwired/stimulus'

// Read-only detail view for one Review-derived supplier delivery pill on the
// dashboard calendar. Delivery dates are edited in the event's Review step —
// the authoritative surface — not here; opening a pill just fills this modal
// from its data-* attributes. All wiring is Stimulus (connect/disconnect), so
// it survives Turbo Drive.
export default class extends Controller {
  static targets = [
    'modal', 'supplierName', 'eventName', 'method',
    'dateLabel', 'date', 'flowersSection', 'flowers', 'viewLink',
  ]

  open(event) {
    const pill = event.currentTarget
    const eventSlug = pill.dataset.eventSlug
    const courier = pill.dataset.method === 'courier'

    this.supplierNameTarget.textContent = pill.dataset.supplier
    this.eventNameTarget.textContent = pill.dataset.eventName
    this.methodTarget.textContent = courier ? 'Courier' : 'Pickup'
    this.dateLabelTarget.textContent = courier ? 'Arrival date' : 'Pickup date'
    this.dateTarget.textContent = pill.dataset.date || '—'
    // The names are pre-joined server-side (the same list the Google entry
    // prints), so this only has to decide whether there is anything to show.
    // A flower whose name can't be resolved contributes nothing, so an empty
    // string means "we can't name these", not "nothing is arriving" — hide the
    // whole section rather than heading an empty line.
    const flowers = (pill.dataset.flowers || '').trim()
    this.flowersTarget.textContent = flowers
    this.flowersSectionTarget.classList.toggle('hidden', flowers === '')
    this.viewLinkTarget.href = `/events/${eventSlug}#review`

    this.modalTarget.classList.remove('hidden')
    this.modalTarget.classList.add('flex')
  }

  close() {
    this.modalTarget.classList.add('hidden')
    this.modalTarget.classList.remove('flex')
  }

  backdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }
}
